import { useQuery } from '@tanstack/react-query'
import { trainingService } from '../services/trainingService'

export default function useGetLessonByTrainingQuery(trainingId: string) {
  return useQuery({
    queryKey: ['lessons', trainingId],
    queryFn: () => trainingService.getLessonsByTrainingId(trainingId),
  })
}
